import css from './inputbox.module.scss';
import {ChangeEvent, useRef, useState} from 'react';
import {InputboxProps} from './inputbox.types';

export const Inputbox = (props: InputboxProps): JSX.Element => {
	const {placeholder, type, onValueChange} = props;
	const inputRef = useRef<HTMLInputElement>(null);
	const [clearVisibility, setClearVisibility] = useState<boolean>(false);

	const clear = () => {
		setClearVisibility(false);
		onValueChange('');
		/** @desc: Casting in here is safe, since clear button won't be visible until user types something */
		(inputRef.current as HTMLInputElement).value = '';
	};

	const onChange = (ev: ChangeEvent<HTMLInputElement>) => {
		const value = ev.target.value;
		onValueChange(value);

		/** @desc: Using these conditions for setting "setClearVisibility" leads to less re-render */
		if (value.length > 0 && !clearVisibility) {
			setClearVisibility(true);
		}
		if (value.length <= 0 && clearVisibility) {
			setClearVisibility(false);
		}
	};

	return (
		<div className={css.container}>
			<input ref={inputRef} className={css.input} onChange={onChange} placeholder={placeholder} type={type} />
			<div className={css.clear} onClick={clear}>
				{clearVisibility && <img src="/img/inputbox-close.svg" />}
			</div>
		</div>
	);
};
